export const MASTER = 'master';
export const REWARD = 'reward';
